import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { GraduationCap } from 'lucide-react';
import StudentList from './students/StudentList';
import StudentProgress from './students/StudentProgress';
import SendInvitation from '../UserManagement/SendInvitation';
import { invitationAPI } from '../../services/api';
import '../../styles/unified.css';

const Students = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [activeTab, setActiveTab] = useState('active');
  const [showCreateForm, setShowCreateForm] = useState(false);

  const statusTabs = [
    { key: 'active',    label: 'Active',    color: '#10b981' },
    { key: 'progress',  label: 'Progress',  color: '#2563eb' },
    { key: 'invited',   label: 'Invited',   color: '#21dc14ff' },
    { key: 'approve',   label: 'Approve',   color: '#f59e0b' },
    { key: 'inactive',  label: 'Inactive',  color: '#6b7280' },
    { key: 'passed',    label: 'Passed',    color: '#2563eb' },
    { key: 'delete',    label: 'Delete',    color: '#ef4444' }
  ];

  const handleNewStudent = () => {
    setShowCreateForm(true);
  };

  const handleCloseForm = () => {
    setShowCreateForm(false);
    // Refresh student list to show "Invited" status
  };

  const handleSendInvitation = async (invitationData) => {
    console.log('Sending invitation:', invitationData);
    
    // Call API to send invitation
    const response = await invitationAPI.sendInvitation(invitationData, getAccessTokenSilently);
    
    console.log('Invitation sent successfully:', response);
    
    // Success message is now handled in the modal
    // Modal will close automatically after showing success
  };

  return (
    <div className="page-container">
      {/*
      <div className="page-header">
        <div className="page-header-left">
          <GraduationCap size={32} className="page-icon" />
          <h1 className="page-title">Students</h1>
        </div>
      </div>
      */}

      {/* Status Tabs */}
      <div className="status-tabs">
        {statusTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
            style={{
              '--tab-color': tab.color,
              borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="page-content">
        {activeTab === 'progress' ? (
          <StudentProgress />
        ) : showCreateForm ? (
          <SendInvitation
            onClose={handleCloseForm}
            onSend={handleSendInvitation}
          />
        ) : (
          <StudentList
            status={activeTab}
            onNewStudent={handleNewStudent}
          />
        )}
      </div>
    </div>
  );
};

export default Students;